import Grid from 'components/Grid';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FieldsGridRowWrapper: FunctionComponent<Props> = ({
    children,
    ref,
    style,
    testId = TEST_ID
}) => (
    <Grid className={styles.fieldsGridRowWrapper} ref={ref} style={style} testId={testId}>
        {children}
    </Grid>
);

export default FieldsGridRowWrapper;
